import { render, staticRenderFns } from "./2_product_center_details_5.vue?vue&type=template&id=ecf84b70&scoped=true&"
import script from "./2_product_center_details_5.vue?vue&type=script&lang=js&"
export * from "./2_product_center_details_5.vue?vue&type=script&lang=js&"
import style0 from "./2_product_center_details_5.vue?vue&type=style&index=0&id=ecf84b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf84b70",
  null
  
)

export default component.exports